import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

const ProgressBar = ({ progress = null, label, testId = 'progress-bar' }) => {
  const isIndeterminate = progress === null || progress === undefined;

  return (
    <S.Wrapper data-testid={testId}>
      <S.LabelRow>
        <S.Label>{label}</S.Label>
        {!isIndeterminate && <S.Percent>{`${progress}%`}</S.Percent>}
      </S.LabelRow>
      <S.Track>
        <S.Fill $indeterminate={isIndeterminate} $percent={isIndeterminate ? 0 : progress} />
      </S.Track>
    </S.Wrapper>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number,
  label: PropTypes.string.isRequired,
  testId: PropTypes.string
};

export default ProgressBar;
